import { GRACE_PERIOD_DAYS } from "../pages/superadmin/pricing";

/**
 * Estado de una suscripción a partir de su vigencia. Lo usan el superadmin (con su
 * color por `key`) y "Mi cuenta" del negocio (con el pill del panel).
 * key: active | grace | expired | inactive | unknown
 */
export function getSubscriptionStatus(expiresAtStr, isActive) {
  const fmt = (d) => d.toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" });
  if (!expiresAtStr) {
    return { key: isActive ? "active" : "inactive", label: isActive ? "Activa" : "Inactiva", relative: "", expiresLabel: "" };
  }
  const exp = new Date(expiresAtStr);
  if (isNaN(exp.getTime())) return { key: "unknown", label: "—", relative: "", expiresLabel: "" };
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const expDay = new Date(exp); expDay.setHours(0, 0, 0, 0);
  const daysLeft = Math.round((expDay - today) / 86400000);
  const expiresLabel = fmt(exp);
  const plural = (n) => (Math.abs(n) === 1 ? "" : "s");
  if (!isActive) return { key: "inactive", label: "Inactiva", relative: "", expiresLabel, daysLeft };
  if (daysLeft >= 0) {
    return { key: "active", label: "Activa", relative: daysLeft === 0 ? "Vence hoy" : `Faltan ${daysLeft} día${plural(daysLeft)}`, expiresLabel, daysLeft };
  }
  if (daysLeft >= -GRACE_PERIOD_DAYS) {
    const graceLeft = GRACE_PERIOD_DAYS + daysLeft;
    return { key: "grace", label: "En gracia", relative: `Venció hace ${-daysLeft} día${plural(daysLeft)} · ${graceLeft} de gracia`, expiresLabel, daysLeft, graceLeft };
  }
  return { key: "expired", label: "Vencida", relative: `Venció hace ${-daysLeft} días`, expiresLabel, daysLeft };
}
